export default "__VITE_ASSET__1a4cdc28__"